// node-modules
import { TimelineMax, TweenMax } from 'gsap/TweenMax';

// other
import selectors from '../animation-selectors';

function getAssets(section, subtitle) {
  return {
    number: section.querySelector(`${subtitle} ${selectors.number}`),
    text: section.querySelector(`${subtitle} ${selectors.text}`),
  };
}

export default {
  trigger: selectors.eyebrow,
  set() {
    const { number, text } = getAssets(this.section, selectors.eyebrow);
    return TweenMax.set([number, text], { autoAlpha: 0 });
  },

  animate() {
    const { number, text } = getAssets(this.section, selectors.eyebrow);
    const tl = new TimelineMax();
    return tl
      .fromTo(number || 'undefined', selectors.duration, { autoAlpha: 0, x: 0 }, { autoAlpha: 1, clearProps: 'all' }, selectors.delay.stage_0)
      .fromTo(text, selectors.duration, { x: -20, autoAlpha: 0 }, { x: 0, autoAlpha: 1, clearProps: 'all' }, selectors.delay.stage_2);
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/eyebrow.js